module.exports = __webpack_public_path__ + "static/media/account_select.103013b5.svg";